var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-card-body',[_c('b-card-text',[_vm._v("SUBSCRIPTION")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }